import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { TNpsAnswer } from '../types/NpsReview';

const NPS_REVIEWS_PATH = '/auth-service/users/me/nps-reviews';

/**
 * Records the signed-in person's NPS answer. auth-service takes the person from
 * the access token and ignores the office header, so an answer is one person's,
 * whichever office is selected. It answers 204 with no body, and a second answer
 * within 180 days of the last one is ignored server-side (still 204).
 */
export const submitNpsReview = async (answer: TNpsAnswer): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.post(NPS_REVIEWS_PATH, answer, { headers });
};
